<script>
import moment from 'moment'

export default {
  name: 'EmailModeration',
  data: function() {
    return {
      loadAllQuery: /* GraphQL */ `
        query loadEmails($personId: Int!) {
          allModerationEmails {
            nodes {
              subject
              date
              from
              id
            }
          }
          allPeople(condition: { personId: $personId }) {
            nodes {
              email
            }
          }
        }
      `,
      loadEmailQuery: /* GraphQL */ `
        query loadRecord($id: String!) {
          allModerationEmails(id: $id) {
            nodes {
              subject
              date
              from
              id
              message
              attachments {
                contentType
                size
                filename
                data
              }
            }
          }
        }
      `,
      distributeEmailQuery: /* GraphQL */ `
        mutation moderateEmail($id: String!) {
          distributeEmail(id: $id)
        }
      `,
      rejectEmailQuery: /* GraphQL */ `
        mutation moderateEmail($id: String!) {
          rejectEmail(id: $id)
        }
      `,
      moderationListFields: [
        {
          key: 'list',
          sortable: true
        },
        {
          key: 'date',
          sortable: true,
          formatter: val => {
            return moment(val).format('MM/DD/YYYY hh:mm A')
          }
        },
        {
          key: 'from',
          sortable: true
        },
        {
          key: 'subject',
          sortable: true
        },
        {
          key: 'edit',
          label: 'Moderate'
        }
      ],
      filter: '',
      userEmail: '',
      moderationEmails: [],
      currentEmail: {}
    }
  },
  computed: {},
  methods: {
    loadModerationEmails: function() {
      this.graphql(this.loadAllQuery, () => {
        return {
          personId: parseInt(this.$store.state.personId)
        }
      }).then(data => {
        this.userEmail = data.allPeople.nodes[0].email
        this.moderationEmails = data.allModerationEmails.nodes.map(email => {
          email.list = email.id.split('@')[0]
          return email
        })
      })
    },
    moderateEmail: function(record) {
      this.graphql(this.loadEmailQuery, {
        id: record.item.id
      }).then(data => {
        this.currentEmail = data.allModerationEmails.nodes[0] || {}
        this.currentEmail.list = this.currentEmail.id.split('@')[0]
        this.$bvModal.show('moderate-email')
      })
    },
    distributeEmail: function() {
      this.graphql(this.distributeEmailQuery, {
        id: this.currentEmail.id,
        sender: this.userEmail
      }).then(() => {
        this.showSuccess = false
        alert(
          'Email Distributed, it may take a minute for Sympa to process the request and the email to be removed from the list'
        )
        this.$bvModal.hide('moderate-email')
        this.currentEmail = {}
        this.loadModerationEmails()
      })
    },
    rejectEmail: function() {
      this.graphql(this.rejectEmailQuery, {
        id: this.currentEmail.id,
        sender: this.userEmail
      }).then(() => {
        this.showSuccess = false
        alert(
          'Email Rejected, it may take a minute for Sympa to process the request and the email to be removed from the list'
        )
        this.$bvModal.hide('moderate-email')
        this.currentEmail = {}
        this.loadModerationEmails()
      })
    }
  },
  mounted() {
    this.loadModerationEmails()
  }
}
</script>

<template>
  <div>
    <h2>Email Moderation</h2>
    <b-row>
      <b-col lg="8">
        <b-form-group
          label-cols-lg="2"
          label="Search"
          label-for="filter"
          label-size="lg"
        >
          <b-input-group size="lg">
            <b-form-input
              v-model="filter"
              id="filter"
              type="search"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4">
        <b-button class="button" @click="loadModerationEmails">
          Reload List
        </b-button>
      </b-col>
    </b-row>
    <br />
    <ResultsTable
      :results="moderationEmails"
      @editRecord="moderateEmail"
      :fields="moderationListFields"
      :filter="filter"
    />
    <b-modal
      id="moderate-email"
      title="Moderate Email"
      size="lg"
      centered
      hide-footer
    >
      <b-row>
        <b-col lg="2"><b>Email List</b></b-col>
        <b-col>{{ currentEmail.list }}</b-col>
      </b-row>
      <b-row>
        <b-col lg="2"><b>Date</b></b-col>
        <b-col>{{ currentEmail.date }}</b-col>
      </b-row>
      <b-row>
        <b-col lg="2"><b>From</b></b-col>
        <b-col>{{ currentEmail.from }}</b-col>
      </b-row>
      <b-row>
        <b-col lg="2"><b>Subject</b></b-col>
        <b-col>{{ currentEmail.subject }}</b-col>
      </b-row>
      <b-row>
        <b-col lg="2"><b>Message</b></b-col>
        <b-col><span v-html="currentEmail.message"></span></b-col>
      </b-row>
      <b-row v-if="currentEmail.attachments && currentEmail.attachments.length">
        <b-col lg="2"><b>Attachments</b></b-col>
        <b-col>
          <b-row>
            <b-col
              v-for="(attachment, aIndex) in currentEmail.attachments"
              :key="aIndex"
            >
              <a
                :href="
                  `data:${attachment.contentType};base64,${attachment.data}`
                "
                :download="attachment.filename"
              >
                {{ attachment.filename }}
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row class="text-center">
        <b-col>
          <b-button class="button" @click="distributeEmail">
            Distribute
          </b-button>
        </b-col>
        <b-col>
          <b-button class="button" @click="rejectEmail">
            Reject
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
